export default "__VITE_ASSET__BuvWQcx___"